let current: { matchId: string; token: string } | null = null;

export function receiveRemoteControl(matchId: string): void {
  const url = new URL(window.location.href);
  const fragment = new URLSearchParams(url.hash.slice(1));
  const token = fragment.get('control');
  current = token ? { matchId, token } : null;
}

export function remoteControlHeaders(path: string): Record<string, string> | null {
  const match = /^\/api\/matches\/([^/]+)\//.exec(path);
  if (!current || !match || decodeURIComponent(match[1]!) !== current.matchId) return null;
  return { 'x-match-control': current.token };
}
